import React, { useState } from 'react';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (searchQuery.trim()) {
      alert('搜索功能开发中，敬请期待！\n搜索关键词: ' + searchQuery);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    if (targetId) {
      const target = document.querySelector(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <header>
      <div className="container">
        <nav>
          <a href="#" className="logo" onClick={(e) => handleNavClick(e, null)}>食光</a>
          <ul className="nav-links">
            <li><a href="#" onClick={(e) => handleNavClick(e, null)}>首页</a></li>
            <li><a href="#recipes" onClick={(e) => handleNavClick(e, '#recipes')}>食谱</a></li>
            <li><a href="#categories" onClick={(e) => handleNavClick(e, '#categories')}>分类</a></li>
            <li><a href="#" onClick={(e) => handleNavClick(e, null)}>关于</a></li>
          </ul>
          <div className="search-box">
            <input
              type="text"
              placeholder="搜索食谱..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button onClick={handleSearch}>🔍</button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
